import React, { useContext } from 'react';
import SurveyItem from '../../util/SurveyItem';
import { Text } from '@lifeomic/chroma-react/components/Text';
import withCheckForEnablement, {
  WithCheckForEnablementInjectedProps,
} from '../hoc/withCheckForEnablement';
import {
  WithStyles,
  createStyles,
  withStyles,
  Theme,
} from '@lifeomic/chroma-react/styles';
import getSurveyItemTestId from '../../util/getSurveyItemTestId';
import { getTestProps } from '../../../../util/testProps';
import clsx from 'clsx';
import SurveyImage from '../SurveyImage';
import { SurveyContext } from '../Contexts';

export const testIds = {
  display: (linkId: string) => getSurveyItemTestId(linkId),
};

const styles = (theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    subTitleDisplay: {
      marginTop: theme.spacing(1),
      color: theme.palette.text.hint,
    },
    denseMarginRoot: {
      marginTop: theme.spacing(2),
    },
  });

export interface ImageOwnProps {
  surveyItem: SurveyItem;
}

export type ImageProps = WithStyles<typeof styles> &
  WithCheckForEnablementInjectedProps &
  ImageOwnProps;

const Display: React.FunctionComponent<ImageProps> = (props: ImageProps) => {
  const surveyId = useContext(SurveyContext)?.id;

  if (!props.isEnabled) return null;

  const rootClass = clsx(
    props.classes.root,
    props.surveyItem.hasDenseMargins && props.classes.denseMarginRoot,
  );

  return (
    <div
      className={rootClass}
      {...getTestProps(testIds.display(props.surveyItem.link))}
    >
      <SurveyImage imageId={props.surveyItem.imageId} surveyId={surveyId} />
      {props.surveyItem.hasText && (
        <Text size="caption" className={props.classes.subTitleDisplay}>
          {props.surveyItem.text}
        </Text>
      )}
    </div>
  );
};

export default withStyles(styles)(withCheckForEnablement(Display));
